/**
 * Invisible hit-area extensions for small controls (mobile UX audit F15).
 *
 * WCAG 2.2 SC 2.5.8 wants 24 × 24 CSS px per target and Apple's HIG 44 × 44 pt,
 * but some controls are small by design (14 px footer links, the 25 px address
 * toggle). These classes grow the TAPPABLE box with an absolutely positioned
 * ::after pseudo-element, so the visible element keeps its exact size, colour
 * and layout — clicks on the pseudo-element still land on the control.
 *
 * Pick the variant that fits the space around the control so adjacent hit
 * areas do not overlap.
 */

const BASE = "relative after:absolute after:content-['']";

/** 44 px tall, full width of the control, centred (buttons / links with room above and below). */
export const TAP_TARGET_44_ROW = `${BASE} after:inset-x-0 after:top-1/2 after:h-[44px] after:-translate-y-1/2`;

/** 24 px tall (the WCAG floor), full width — for links stacked close together (footer lists). */
export const TAP_TARGET_24_ROW = `${BASE} after:inset-x-0 after:top-1/2 after:h-[24px] after:-translate-y-1/2`;

/** The 25 px address-mode toggle → 36 px: the inputs above and below sit too close for a full 44. */
export const TAP_TARGET_ADDRESS_TOGGLE = `${BASE} after:inset-x-0 after:-top-[6px] after:-bottom-[5px]`;
